export const V6_SLUG_MAP: Record<string, string> = {
  old_brunette_athletic: 'lacey-k42bnt',
  old_blonde_skinny: 'laura-jttsfv',
  old_brunette_regular: 'lauren-yqr3d6',
  old_black_athletic: 'leah-p8uqhm',
  old_black_regular: 'leila-jkud3k',
  old_blonde_plus_size: 'lenka-fd651t',
  old_blonde_athletic: 'liana-q8ggj8',
  old_red_regular: 'lillie-yrbths',
  old_brunette_skinny: 'lindsey-wrgbrn',
  old_blonde_regular: 'liz-mqpsaj',
  old_red_plus_size: 'lola-2ebq0q',
  old_black_plus_size: 'london-s3amd1',
  old_black_skinny: 'lucile-zfvwyw',
  old_brunette_plus_size: 'luna-0v2tbs',
  old_red_skinny: 'luzia-jmxsmn',
  old_red_athletic: 'lydia-s3r6w7',
  young_blonde_plus_size: 'sabrina-abi0tj',
  young_red_regular: 'sally-ptgtt4',
  young_blonde_regular: 'salome-h2s4l0',
  young_brunette_regular: 'sam-bixg4w',
  young_brunette_plus_size: 'samantha-ahvlne',
  young_red_skinny: 'sandra-qavlbr',
  young_black_regular: 'sandy-gpfk8h',
  young_brunette_skinny: 'sarah-urfc13',
  young_black_athletic: 'sasha-p6vx37',
  young_red_athletic: 'selena-zg7rnb',
  young_brunette_athletic: 'serena-pif6ni',
  young_black_skinny: 'sinti-g7q6zv',
  young_black_plus_size: 'sophie-nzh0st',
  young_blonde_athletic: 'stefania-fe0kvv',
  young_red_plus_size: 'summer-9oqw71',
  young_blonde_skinny: 'susan-w8jmtz',
};
